<template>
  <div>

    <collapse
      v-for="(item, key) in collapses"
      :key="key"
      v-if="key === 'x5' ? true : $store.state.subjectType === 'b'"
      :collapse-id="key"
      :sub-active-check="item.sach"
      :title="item.title">
      <nav-link
        class="upCase"
        v-for="(i, k) in item.links"
        :key="k"
        v-if="zahranicnePages.includes(k) ? $store.state.rezident : true"
        :to="{ name: k }">
        {{ i }}
      </nav-link>
    </collapse>

    <nav
      v-if="$store.state.subjectType === 'b'"
      class="nav flex-column nav-pills nav-editor">
      <nav-link
        class="upCase"
        v-for="(item, key) in links"
        :key="key"
        :to="{ name: key }">
        {{ item }}
      </nav-link>
    </nav>
    <hr>
    <poucenie />
  </div>
</template>

<script>
import Collapse from './Collapse.vue';
import navLink from './navLink.vue';
import poucenie from './poucenie.vue';

export default {
  components: {
    Collapse,
    navLink,
    poucenie
  },
  data() {
    return {
      zahranicnePages: [
        'zahranicnePar5',
        'zahranicnePrijmy6',
        'zahranicnePrijmy6o3',
        'zahranicnePrijmy6o4',
        'zahranicnePrijmy7',
        'zahranicnePrijmy8',
      ],
      collapses: {
        x5: {
          sach: '/prijmyVydavky/:userId/par5',
          title: 'Závislá činnosť (§ 5)',
          links: {
            tuzemskePar5: 'tuzemské príjmy',
            zahranicnePar5: 'zahraničné príjmy',
          },
        },
        x6ods1: {
          sach: '/prijmyVydavky/:userId/par6ods1',
          title: 'Podnikanie a SZČ (§ 6 ods. 1 a 2)',
          links: {
            sposobUct6o12: 'spôsob účtovania',
            tuzPrijmy6o12: 'tuzemské príjmy',
            zahranicnePrijmy6: 'zahraničné príjmy',
          },
        },
        x6ods3: {
          sach: '/prijmyVydavky/:userId/par6ods3',
          title: 'Prenájom (§ 6 ods. 3)',
          links: {
            sposobUctovania6o3: 'spôsob účtovania',
            oslobednePrijmy: 'Oslobodené príjmy z prenájmu',
            tuzemskePrijmy6o3: 'tuzemské príjmy',
            zahranicnePrijmy6o3: 'zahraničné príjmy',
          },
        },
        x6ods4: {
          sach: '/prijmyVydavky/:userId/par6ods4',
          title: 'Licencie (§ 6 ods. 4)',
          links: {
            sposobUctovania6o4: 'spôsob účtovania',
            tuzemskePrijmy6o4: 'tuzemské príjmy',
            zahranicnePrijmy6o4: 'zahraničné príjmy',
          },
        },
        x7: {
          sach: '/prijmyVydavky/:userId/par7',
          title: 'Kapitálové príjmy (§ 7)',
          links: {
            tuzemskePrijmy7: 'tuzemské príjmy',
            zahranicnePrijmy7: 'zahraničné príjmy',
            urokovePrijmy7: 'úrokové príjmy',
          },
        },
        x8: {
          sach: '/prijmyVydavky/:userId/par8',
          title: 'Ostatné (§ 8)',
          links: {
            tuzemskePrijmy8: 'tuzemské príjmy',
            zahranicnePrijmy8: 'zahraničné príjmy',
          },
        },
      },
      links: {
        tabulkaOMajetku: 'tabuľka o majetku',
        poistneOdvody: "Poistné - odvody -zaplatené v tuzemsku z príjmov podľa § 6 ods.1,2'",
        preddavky: 'preddavky',
        odpocetDanovejStraty: 'odpočet daňovej straty',
        sposobZahrnovania: 'spôsob zahrnovania kurzových rozdielov',
        rekreacia: 'Príspevok na rekreáciu'
      },
    };
  }
};
</script>
